import React, { useState } from 'react';
import { Image, Server } from '../../../Cloud.model';
import ImageIconCard from './Card/ImageIconCard';
import ImageListLines from './ImageListLines/ImageListLines';
import { getCardByImage } from './Card/ImageIconCard.service';
import { Cards } from './Card/ImageIconCard.model';
import './ImageList.scss';
import { UHCLockImageProps } from '../LockImage/LockImage';

export interface UHCImageListProps {
    images: Image[],
    imageChecked: Image,
    server?: Server,
    layout: 'list' | 'card',
    hardware: UHCLockImageProps['hardware'],
    setImageChecked: (images: Image[], index: number) => void,
    clickChangeHardware: (image: Image) => void
}

export const UHCImageList: React.FC<UHCImageListProps> = (props: UHCImageListProps) => {
    const [cardChecked, setCardChecked] = useState<Cards>(getCardByImage(props.imageChecked));

    return (
        <fieldset className="image-list zero-form-check-group-container zero-form-check-group--vertical">
            <legend>Selecione o Template para a sua configuração</legend>
            <ImageIconCard
                layout={props.layout}
                cardChecked={cardChecked}
                setCardChecked={setCardChecked}
            />

            <ImageListLines
                images={props.images}
                layout={props.layout}
                imageChecked={props.imageChecked}
                hardware={props.hardware}
                server={props.server}
                filter={cardChecked}
                setImageChecked={props.setImageChecked}
                clickChangeHardware={props.clickChangeHardware}

            />

        </fieldset>
    );
};
